import { render, staticRenderFns } from "./SuggestedSkillsEmptySkills.vue?vue&type=template&id=1887cc6e&scoped=true&"
import script from "./SuggestedSkillsEmptySkills.vue?vue&type=script&lang=js&"
export * from "./SuggestedSkillsEmptySkills.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedSkillsEmptySkills.vue?vue&type=style&index=0&id=1887cc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887cc6e",
  null
  
)

export default component.exports